import {lastValueFrom} from "rxjs";
import {AbstractHttpService} from "../../persist/http/AbstractHttpService";
import {Entidade} from "../../../domain/Entidade";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {SQLiteService} from "../../sqlite.service";
import {inject} from "@angular/core";

export abstract class AbstractUpload<T extends Entidade> {
    sqlite: SQLiteService
    constructor(public nome: string, protected service: AbstractHttpService<T>,private classe: any) {
      this.sqlite = inject(SQLiteService)
    }

    async sendRecords(){
        const pendencias = await  this.getPendencias()
        if(pendencias.length > 0) {
            console.log('enviando',pendencias.length, pendencias)
            await lastValueFrom(this.service.bulk(this.transformBeforeSend(pendencias)))
            pendencias.forEach(r => r.situacao = EnumSincronizacao.ENVIADO)
            console.log('gravando o retorno', pendencias)
            const repo = LocalDataSource.getRepository(this.classe)
            await repo.save(pendencias)
            await this.sqlite.saveToStore()
        }
    }

    transformBeforeSend(items: T[]): any[]{
        return items
    }

    async getPendencias(): Promise<any[]>{
      const repo = LocalDataSource.getRepository(this.classe)
      return repo.find({where: {situacao: EnumSincronizacao.ENVIAR}})
    }
}

